import { createRoutes } from 'shared/hocs'

import { MakeInWinAdd } from './overview/components/add'

const MakeInwin = createRoutes(({ match }) => [
  {
    exact: true,
    path: `${match.path}/add/:eventId`,
    component: MakeInWinAdd,
  },
])

export default MakeInwin
